<div class="tenant-dashboard" [testId]="'tenant-dashboard-container'">
  <h2 class="dashboard-title" [testId]="'tenant-dashboard-title'">
    {{ currentTenant?.name ?? ('dashboard.tenant' | i18n) }}{{ 'dashboard.overview' | i18n }}
  </h2>

  <div nz-row [nzGutter]="12" [testId]="'tenant-dashboard-grid'">
    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="mb-4" [testId]="'tenant-dashboard-col-aiff'">
      <nz-card class="statistic-card" [testId]="'tenant-dashboard-card-aiff'">
        <nz-statistic
          [nzValue]="(statistics.aiffCount | number)!"
          [nzTitle]="'dashboard.aiff-app-count' | i18n"
          [nzPrefix]="appPrefix"
          [nzLoading]="loading"
          [testId]="'tenant-dashboard-statistic-aiff'"
        />
        <ng-template #appPrefix>
          <i nz-icon nzType="appstore" class="statistic-icon app-icon" [testId]="'tenant-dashboard-icon-aiff'"></i>
        </ng-template>
      </nz-card>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="mb-4" [testId]="'tenant-dashboard-col-employee'">
      <nz-card class="statistic-card" [testId]="'tenant-dashboard-card-employee'">
        <nz-statistic
          [nzValue]="(statistics.employeeCount | number)!"
          [nzTitle]="'dashboard.employee-count' | i18n"
          [nzPrefix]="employeePrefix"
          [nzLoading]="loading"
          [testId]="'tenant-dashboard-statistic-employee'"
        />
        <ng-template #employeePrefix>
          <i nz-icon nzType="team" class="statistic-icon employee-icon" [testId]="'tenant-dashboard-icon-employee'"></i>
        </ng-template>
      </nz-card>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="mb-4" [testId]="'tenant-dashboard-col-service'">
      <nz-card class="statistic-card" [testId]="'tenant-dashboard-card-service'">
        <nz-statistic
          [nzValue]="(statistics.serviceNumberCount | number)!"
          [nzTitle]="'dashboard.service-number-count' | i18n"
          [nzPrefix]="servicePrefix"
          [nzLoading]="loading"
          [testId]="'tenant-dashboard-statistic-service'"
        />
        <ng-template #servicePrefix>
          <i nz-icon nzType="customer-service" class="statistic-icon service-icon" [testId]="'tenant-dashboard-icon-service'"></i>
        </ng-template>
      </nz-card>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="mb-4" [testId]="'tenant-dashboard-col-business'">
      <nz-card class="statistic-card" [testId]="'tenant-dashboard-card-business'">
        <nz-statistic
          [nzValue]="(statistics.bossServiceNumberCount | number)!"
          [nzTitle]="'dashboard.business-number-count' | i18n"
          [nzPrefix]="businessPrefix"
          [nzLoading]="loading"
          [testId]="'tenant-dashboard-statistic-business'"
        />
        <ng-template #businessPrefix>
          <i nz-icon nzType="shop" class="statistic-icon business-icon" [testId]="'tenant-dashboard-icon-business'"></i>
        </ng-template>
      </nz-card>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="mb-4" [testId]="'tenant-dashboard-col-customer'">
      <nz-card class="statistic-card" [testId]="'tenant-dashboard-card-customer'">
        <nz-statistic
          [nzValue]="(statistics.contactCount | number)!"
          [nzTitle]="'dashboard.customer-count' | i18n"
          [nzPrefix]="customerPrefix"
          [nzLoading]="loading"
          [testId]="'tenant-dashboard-statistic-customer'"
        />
        <ng-template #customerPrefix>
          <i nz-icon nzType="user" class="statistic-icon customer-icon" [testId]="'tenant-dashboard-icon-customer'"></i>
        </ng-template>
      </nz-card>
    </div>
  </div>
</div>
